<template>
  <div>
    <editPdfWindow
      v-if="showEditPdf"
      @close="showEditPdf = false"
      :nameBook="bookName"
      :nameAuthor="author"
      :id="book.id"
    />

    <div
      v-if="showBookRow"
      :id="(searchMode ? 'freebook_' : 'book_') + listIndex"
      :book="book.id"
      :inx="inx"
      class="item-book"
      :activeInScroll="activeInScroll"
      :class="{
        open: showVolumes,
        check: checked,
        vol: hasVolumes,
        favorite: favoriteBooksById,
        active: isActive,
        select: select && select == book.id,
        'item-vol': isVol,
      }"
      @click="manageItemClicks"
      @dblclick="openBookInNewWindow($event, true)"
      @click.ctrl="openBookInRealNewWindow"
      @click.shift="openItem($event, true)"
      @contextmenu="openContexMenu"
    >
      <BaseContextMenu @close="closeContexMenu" v-if="hiddenBooksList">
        <!--    for hidden books list    -->
        <div
          v-kiosk
          v-if="enableHide && booksChecked.length == 1"
          class="menu-item"
          @click="removeHiddenBooks"
          v-disable
        >
          {{ $t("general.cancelHiddenBook") }}
        </div>
        <div
          v-kiosk
          class="menu-item"
          @click="removeHiddenBooks"
          v-disable
          v-if="enableHide && booksChecked.length > 1"
        >
          {{ $t("general.cancelHiddenBook") }}
        </div>
      </BaseContextMenu>

      <BaseContextMenu @close="closeContexMenu" v-if="!hiddenBooksList">
        <div
          class="menu-item"
          @click="openItem"
          v-if="booksChecked.length == 1"
        >
          {{ $t("general.open") }}
        </div>
        <div
          class="menu-item"
          @click="openItem($event, true)"
          v-if="booksChecked.length == 1"
        >
          {{ $t("listBooks.openNewTab") }}
        </div>
        <div
          class="menu-item"
          @click="openBookInNewWindow"
          v-if="booksChecked.length == 1"
        >
          {{ $t("listBooks.openNewWindow") }}
        </div>
        <div
          v-kiosk
          class="menu-item"
          v-if="getCurrentListType != 'SAVED_LIST'"
          @click="saveInList"
        >
          {{ $t("actionBook.saveList") }}
        </div>
        <div
          class="menu-item"
          v-if="getCurrentListType == 'SAVED_LIST'"
          @click="removeFromList"
        >
          {{ $t("actionBook.deleteFromList") }}
        </div>
        <div
          v-kiosk
          class="menu-item"
          v-if="getCurrentListType == 'SAVED_LIST'"
          @click="saveInList"
        >
          {{ $t("actionBook.saveNewList") }}
        </div>
        <div
          class="menu-item"
          v-kiosk
          @click="toggleFavorites"
          v-if="!getCurrentListType && booksChecked.length == 1"
        >
          {{ $t("actionBook.addFavorits") }}
        </div>

        <div
          class="menu-item"
          v-kiosk
          @click="toggleFavorites"
          v-if="getCurrentListType && booksChecked.length == 1"
        >
          <span v-if="!favoriteBooksById">
            {{ $t("actionBook.addFavorits") }}</span
          >
          <span v-else> {{ $t("actionBook.removeFavorits") }}</span>
        </div>

        <div
          class="menu-item"
          v-kiosk
          @click="toggleFavorites"
          v-if="booksChecked.length > 1 && getFavoriteCheckBooksCount == 1"
        >
          <span v-if="!favoriteBooksById">
            {{ $t("actionBook.removeFavorits") }}</span
          >
          <span v-else> {{ $t("actionBook.removeFavorits") }}</span>
        </div>

        <div
          class="menu-item"
          @click="toggleFavorites"
          v-kiosk
          v-if="booksChecked.length > 1 && getFavoriteCheckBooksCount == 0"
        >
          <span v-if="!favoriteBooksById">
            {{ $t("actionBook.addFavorits") }}</span
          >
          <span v-else> {{ $t("actionBook.removeFavorits") }}</span>
        </div>
        <!-- disable for demo -->
        <div class="menu-item" @click="addQuickBtn" v-kiosk>
          {{ $t("actionBook.addBtn") }}
        </div>
        <div
          v-kiosk
          v-if="enableHide && booksChecked.length == 1"
          class="menu-item"
          @click="addToHiddenBooks"
          v-disable
        >
          {{ $t("actionBook.hideBook") }}
        </div>
        <div
          v-kiosk
          class="menu-item"
          @click="addToHiddenBooks"
          v-disable
          v-if="enableHide && booksChecked.length > 1"
        >
          {{ $t("selectBook.hideSelectBook") }}
        </div>

        <div
          v-kiosk
          class="menu-item"
          v-show="otzarBook.type(book.id) == 'custom'"
          @click="openCusBookForEdit(book.id)"
        >
          {{ $t("actionBook.editBook") }}
        </div>
        <div
          class="menu-item"
          @click="createShortcutForThisBook"
          v-kiosk
          v-version.up="23"
        >
          {{ $t("customShortcuts.setShortcut") }}
        </div>
      </BaseContextMenu>
      <baseCheckBox
        :checked="checked"
        class="check-item"
        :class="{ 'show-mobile': $_mobile }"
        @change="check($event, book.id, listIndex)"
        @click="click"
        size="small"
      />
      <div class="container-text-item">
        <div class="inner-text-item" :class="{ machonim: isMachon, fs: isFs }">
          <nameBook :name="bookName" />
          <nameAuthor :name="author" />
          <publishInfo v-if="pubData != ''" :info="pubData" />
        </div>

        <div class="show-machonim mrg-r-3" v-if="isFs && result === ''">
          <!-- &nbsp; -->
          [<span class="num">{{ FSNumResults }}</span
          >]
        </div>
        <div
          class="show-machonim mrg-r-3 flex flex-align-center"
          v-if="isMachon"
        >
          <span class="machon">{{ iconMachon }}</span>
        </div>
        <!-- </div> -->
      </div>

      <div
        class="icons flex-g-1 flex-bet"
        :class="{ 'icons-mobile': $_mobile }"
      >
        <!-- <div class="" style="width:2px;height:100%;"></div> -->

        <!-- <div class="123" v-if="result != ''" v-html="result"></div> -->
        <div class="flex dir-rtl flex-align-center">
          <div
            v-show="otzarBook.type(book.id) == 'custom'"
            class="otz-icon edit no-bg icon-outer edit-book"
            v-tooltip="{
              content: this.$t('itemBook1.edit'),
              placement: 'right',
            }"
            @click="openCusBookForEdit(book.id)"
          >
            c
          </div>
          <div
            v-kiosk
            v-show="otzarBook.type(book.id) == 'customPDF'"
            class="otz-icon edit no-bg icon-outer edit-book"
            v-tooltip="{
              content: this.$t('itemBook1.edit'),
              placement: 'right',
            }"
            @click.stop="openEditPdfBook(book.id)"
          >
            c
          </div>
          <!-- <div
            v-show="otzarBook.type(book.id) == 'custom'"
            class="otz-icon delete no-bg icon-outer"
            v-tooltip="{
              content: 'מחק ספר אישי',
              placement: 'right',
            }"
            @click="() => {}"
          >
            9
          </div> -->
          <baseIcon
            class="icon-outer books-author"
            nameIcon="books-author"
            pathIcon="icons-ganeral"
            width="11"
            height="15"
            @click.stop="openListBooksAuthor(book.id, author, book)"
            v-if="!typefree"
            v-tooltip="{
              content: this.$t('tooltip.booksAuthor'),
              placement: 'top',
            }"
          />
          <baseIcon
            class="icon-outer"
            nameIcon="book-info"
            pathIcon="icons-ganeral"
            width="6"
            height="15"
            @click.stop="toggleBookDetailsVisible(book.id)"
            v-tooltip="{
              content: infoTooltip,
              placement: 'top',
              classes: [
                'machon-tooltip',
                isFs ? 'b' : '',
                isVolumesHeader ? 'b' : '',
              ],
            }"
          />
          <baseIcon
            v-kiosk
            class="icon-outer favorites-icon 3"
            :class="{ favorite: favoriteBooksById }"
            nameIcon="favorites-list-book"
            pathIcon="icons-ganeral"
            width="16"
            height="16"
            @click.stop="toggleFavoritesItem"
            v-tooltip="{ content: favoriteTooltip, placement: 'top' }"
            v-if="!$_mobile"
          />

          <div
            v-if="isFs && !$_mobile && resultType === 0"
            class="show-num-fs 2 icon-outer"
            @click.stop="doToggleGzirim"
            :class="{ open: gzirim.show }"
          >
            <span class="icon-gzir">
              <baseIcon
                class="icon-fill-gzir"
                nameIcon="book-fill-gzir"
                pathIcon="icons-ganeral"
                width="14"
                height="14"
              />
            </span>
            <baseIcon
              class="icon-outer icon-gzir-empty"
              nameIcon="book-gzir"
              pathIcon="icons-ganeral"
              width="14"
              height="14"
            />
          </div>

          <div
            class="show-sum-vol 1"
            :class="{ open: showVolumes }"
            v-if="isVolumesHeader"
            @click.stop="toggleVol"
          >
            <span class="num" v-if="!showVolumes">{{
              book.volumes_length
            }}</span>
            <span class="close no-event"> + </span>
            <!-- <span class="close no-event">
           
              -
            </span> -->
          </div>

          <div
            class="show-sum-vol small 1"
            v-if="isVol && !showVols"
            @click.stop="setVol(false)"
          >
            <span class="icon-minus">-</span>
          </div>
          <div
            v-if="resultType === 1"
            class="otz-icon tziun-resulte no-bg icon-outer"
            v-tooltip="{
              content: result,
              placement: 'right',
              classes: 'tooltip-darken',
            }"
          >
            N
          </div>
          <div
            v-if="resultType === 2"
            class="key-resulte no-bg"
            v-tooltip="{
              content: result,
              placement: 'right',
              classes: 'tooltip-darken',
            }"
          >
            <BaseIcon
              :width="16"
              :height="16"
              nameIcon="icon-key-gray"
              pathIcon="icons-ganeral"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="gzirim.show === true">
      <div
        v-for="gzir in gzirimToRender"
        :key="book.id + currentFsName + gzir.index"
      >
        <gzir
          :bookIndex="listIndex"
          :gzirIndex="gzir.index"
          :book="book.id"
          :gzirHeight="heightGzir"
          @openbook="openResultInBook"
          :words="gzir.gzir"
        />
      </div>
    </div>
  </div>
</template>

<script>
import nameBook from "@/components/listBookArea/listContentContainer/nameBook.vue";
import publishInfo from "@/components/listBookArea/listContentContainer/publishInfo.vue";
import gzir from "@/components/FreeSearch/gzir.vue";
import nameAuthor from "@/components/listBookArea/listContentContainer/nameAuthor.vue";
import itemBookVol from "@/components/listBookArea/listContentContainer/itemBookVol.vue";
import editPdfWindow from "@/components/editPdfWindow.vue";
import { openBook as open } from "@/services/bookData.js";
import bookwin from "@/services/book_win.js";
import { mapState, mapActions, mapGetters } from "vuex";
import config from "@/config/general";
import { createFreeSearchBookListStore } from "@/store_pinia";

const machonimLicenses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 15, 19, 20, 22];
export default {
  props: {
    book: {},
    activeinx: null,
    inx: null,
    page: null,
    select: false,
    checked: {},
    searchMode: { default: false },
    mefo: { default: false },
    index: {
      default: 0,
    },
    active: null,
    type: {},
    gzirim: {
      type: Object,
      default: () => ({ show: false, results: [] }),
    },
    closeVol: { default: true },
    showVolumes: false,
    startResult: 0,
    endResult: 0,
    lastItem: false,
    volumesCount: 0,
    result: { default: "" },
    resultType: { default: 0 },
    listIndex: 0,
    activeInScroll: false,
    searchId: "",
  },
  data() {
    return {
      open: false,
      tooltipM: "",
      imgs: [],
      contextSelected: null,
      showEditPdf: false,
      //clickTimer: null,
    };
  },
  watch: {
    gzirim: async function (val, oldVal) {
      if (val.show && !oldVal.show) this.getGzirimData();
    },
  },

  computed: {
    ...mapGetters("booklistComp", ["getSortBy"]),
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    isMefActive() {
      return (
        this.mefo &&
        this.$store.state.currentActiveListIndex === this.listIndex.toString()
      );
    },
    gzirimToRender() {
      let gzirim = [...this.fsWordsInResults].map((g, i) => {
        return { gzir: g, index: i };
      });
      let a = gzirim.filter(
        (g, i) =>
          !(
            (this.index == 0 && i < this.startResult) ||
            (this.lastItem && i > this.endResult)
          )
      );

      return a;
    },
    enableHide() {
      return this.userSettings.settings.enableHidden != "0";
    },
    getCheckedBooksLocal() {
      return [10, 4, 103967];
    },
    ...mapGetters("books", [
      "getVolumeByIdBook",
      "getAllVolumesById",
      "getBookbyId",
    ]),

    ...mapGetters("bookList", [
      "getNameListBook",
      "getCurrentListType",
      "showVols",
      "getDataOfCurrentList",
      "getCheckedBooks",
    ]),

    ...mapGetters("userFavoriteBooks", ["getFavoriteBooksById"]),
    ...mapGetters("booklistComp", [
      "hasCheckAll",
      "cancelCheck",
      "hasCheck",
      "hasCheckedTop",
    ]),
    ...mapGetters("freeSearchBooklistComp", [
      "hasCheckAllFree",
      "cancelCheckFree",
      "hasCheckFree",
      "hasCheckedTopFree",
      "getListCheckBooksFree",
    ]),
    ...mapGetters("tabsManager", ["getCurrentBook", "isCurrentTabPinned"]),
    ...mapState("bookList", ["bookSelectedContex", "textSearch"]),
    currentFsName() {
      return this.freeSearchBookListStore?.currentFsName || "";
    },

    showBookRow() {
      return !(
        this.searchMode &&
        this.gzirim &&
        this.index === 0 &&
        this.startResult > 0
      );
    },
    booksChecked() {
      return this.searchMode
        ? this.getListCheckBooksFree
        : this.getCheckedBooks;
    },
    getFavoriteCheckBooksCount() {
      return this.searchMode
        ? this.freeSearchBookListStore.favoriteCheckBooksCount
        : this.$store.state.bookList.getFavoriteCheckBooksCount;
    },
    fsWordsInResults() {
      let results = [];
      if (this.gzirim.results == undefined) return results;
      let numResults = Math.floor(
        this.gzirim.results.length / this.book.fs.results
      );
      let tempArr = [];
      this.gzirim.results.forEach((g, i) => {
        if (i % numResults == 0) {
          if (tempArr.length > 0) {
            results.push(tempArr);
          }
          tempArr = [];
          tempArr.push(g);
        } else tempArr.push(g);
      });
      if (tempArr.length > 0) results.push(tempArr);

      return results;
    },
    hiddenBooksList() {
      return this.getDataOfCurrentList.data.type === "HIDDEN_LIST";
    },
    yesodBook() {
      return (
        this.getDataOfCurrentList.data.type == "CUSTOM_LIST" &&
        this.getDataOfCurrentList.data.content == "ספרי יסוד"
      );
    },
    systemMaagarim() {
      return (
        (this.getDataOfCurrentList.data.type == "SYSTEM_LIST" &&
          this.getDataOfCurrentList.data.categoryTypeId === 4) ||
        this.getDataOfCurrentList.data.type == "SAVED_LIST"
      );
    },

    heightGzir() {
      return config.gzirHeight[
        this.userSettings.settings.height_gzir
          ? this.userSettings.settings.height_gzir
          : "low"
      ];
    },
    // select() {
    //   if (
    //     this.bookSelectedContex.checked &&
    //     this.bookSelectedContex.book == this.book.id
    //   ) {
    //
    //     return true;
    //   }
    //   return false;
    // },
    /*   getBookDetails() {
      return this.getBookbyId(this.bookid);
    }, */
    infoTooltip() {
      let tooltip = "";
      tooltip +=
        "<div class='info-tooltip'><div class='no-wrap-circle'><span class='bold'>" +
        this.$t("bookDetails.bookName") +
        ": </span> <span >" +
        this.bookName +
        "</span></div><div class='no-wrap-circle' ><span class='bold'>" +
        this.$t("bookDetails.bookAuthor") +
        ":  </span> <span>" +
        this.author +
        "</span></div>";
      if (this.book.places != "") {
        tooltip +=
          "<div class='no-wrap-circle'><span class='bold'>" +
          this.$t("bookDetails.bookPlace") +
          ":</span> <span>" +
          this.book.places +
          "</span></div>";
      }
      if (this.book.toyear || this.book.fromyear) {
        tooltip +=
          " <div class='no-wrap-circle'><span class='bold'>" +
          this.$t("bookDetails.bookYear") +
          ": </span> <span>" +
          this.bookYears +
          "</span></div>";
      }
      tooltip +=
        " <div class='no-wrap-circle'><span class='bold'>" +
        this.$t("bookDetails.bookId") +
        ": </span> <span>" +
        this.book.id +
        "</span></div></div>";
      return tooltip;
    },

    isVolumesHeader() {
      return (
        this.hasVolumes &&
        this.showVolumesBtn &&
        !this.showVols &&
        !this.isFs &&
        this.isClose
      );
    },
    isSidraPart() {
      return (
        (this.hasVolumes &&
          this.showVolumesBtn &&
          !this.isFs &&
          this.isClose) ||
        (this.book.position > 1 &&
          !this.showBookVolumes &&
          !this.isFs &&
          !this.typefree &&
          this.isClose)
      );
    },
    isVol() {
      return (
        this.book.mainVolume &&
        this.book.mainVolume != this.book.id &&
        !this.showBookVolumes &&
        !this.isFs &&
        !this.typefree &&
        this.isClose
      );
    },

    isClose() {
      return this.closeVol === true || this.closeVol == undefined;
    },
    favoriteTooltip() {
      if (this.favoriteBooksById) {
        return this.$t("tooltip.removeFavorites");
      } else return this.$t("tooltip.addFavorites");
    },
    isActive() {
      //return this.inx % 2 == 0;

      let activeList =
        (this.searchMode && this.$store.state.lastActiveList === 2) ||
        (!this.searchMode && this.$store.state.lastActiveList === 1);
      return (
        activeList &&
        this.$store.state.currentActiveListIndex === this.listIndex.toString()
      );
    },
    setActive() {
      if (this.active == this.book.id) {
        return true;
      }
      return false;
    },
    FSNumResults() {
      return this.book.fs.results;
    },
    favoriteBooksById() {
      let x = this.$store.state.userFavoriteBooks.favoriteChange;
      return this.book.favorite;
    },
    drawInfo() {
      return this.book.words ? { fs: this.book.words } : {};
    },
    showVolumesBtn() {
      return this.searchMode === false && !this.showBookVolumes;
    },
    isFs() {
      if (this.book.fs == undefined || !this.searchMode) return false;
      return this.book.fs.fs != "";
    },
    isMachon() {
      let _this = this;

      let found = false;
      machonimLicenses.forEach((m) => {
        if ((1 << m) & _this.book.permissions) {
          found = true;
          return;
        }
      });
      return found;
    },
    iconMachon() {
      if (!this.isMachon) return;
      const flag = this.book.permissions;
      let icon = "";
      let tooltip = "";
      if (flag & (1 << 10)) {
        tooltip = "אנצקלופדיה תלמודית";
        icon = "את";
      } else if (flag & (1 << 4)) {
        tooltip = "מוסד הרב קוק";
        icon = "רק";
      } else if (flag & (1 << 5) || flag & (1 << 15)) {
        tooltip = "מכון ירושלים";
        icon = "יר";
      } else if (flag & (1 << 6)) {
        tooltip = "חכמת שלמה";
        icon = "חש";
      } else if (flag & (1 << 7)) {
        tooltip = "אהבת שלום";
        icon = "אש";
      } else if (flag & (1 << 8)) {
        tooltip = "מכון אופק";
        icon = "או";
      } else if (flag & (1 << 9)) {
        tooltip = "עוז והדר";
        icon = "עוז";
      } else if (flag & (1 << 13)) {
        tooltip = "זכרון אהרן";
        icon = "זא";
      } else if (flag & (1 << 3)) {
        tooltip = "מכון הרב מצליח";
        icon = "ממ";
      } else if (flag & (1 << 2)) {
        tooltip = "נזר דוד";
        icon = "נד";
      } else if (flag & (1 << 1)) {
        tooltip = "מאבני המקום";
        icon = "מה";
      } else if (flag & (1 << 19)) {
        tooltip = "מאור ישראל";
        icon = "מע";
      } else if (flag & (1 << 20)) {
        tooltip = "אור לישרים";
        icon = "אל";
      } else if (flag & (1 << 22)) {
        tooltip = `הוצאת אמ״ת`;
        icon = "הא";
      }
      this.tooltipM = tooltip;
      return tooltip;
    },
    typefree() {
      if (this.type == "free") return true;
      return false;
    },
    hasVolumes() {
      if (this.book.volumes_length > 0) {
        return true;
      }
      return false;
    },
    isChecked() {
      if (this.type == "book") return this.isCheck;
      else return this.book.checked;
    },
    isChecked1() {
      if (this.type == "book") return this.isCheck;
      else return this.isCheckFree;
    },
    isCheck() {
      if (!this.hasCheckCurrent) return false;
      if (this.hasCheckAll || this.hasCheckCurrent) return true;
      return false;
    },
    hasCheckCurrent() {
      if (!this.hasCheckedTop) return false;
      let x = this.hasCheck(this.book.id);
      return x;
    },
    isCheckFree() {
      if (!this.hasCheckCurrentFree) return false;
      if (this.hasCheckAllFree || this.hasCheckCurrentFree) return true;
      return false;
    },
    hasCheckCurrentFree() {
      if (!this.hasCheckedTopFree) return false;
      let x = this.hasCheckFree(this.book.id);
      return x;
    },
    showBookVolumes() {
      let listType = this.getCurrentListType;
      if (this.textSearch !== "") return false;
      return (
        this.getSortBy == "year" ||
        (!["SEARCH", "ALL", "AUTHOR_LIST"].includes(listType) &&
          !this.yesodBook &&
          !this.systemMaagarim) /* ||
        this.textSearch == "" */
      );
    },
    singleBook() {
      return this.book.mainVolume == null;
    },
    volumePart() {
      if (this.book.volume.indexOf(">") > -1)
        return this.book.volume.substr(0, this.book.volume.indexOf(">") + 1);
      return "";
      let parts = this.book.volume.split(" - ");
      return parts.length > 1 ? parts[0] : "";
    },
    realVolPart() {
      if (this.book.volume.indexOf(">") > -1)
        return this.book.volume.substr(this.book.volume.indexOf(">") + 1);
      else return this.book.volume;
    },
    bookVolume() {
      let inxOfEnd = this.book.volume.indexOf(">");
      if (inxOfEnd < 0) inxOfEnd = 0;
      let vol = this.book.volume.substring(inxOfEnd, 2).trim();
      let has = vol.includes("-");
      return has || this.book.volume.indexOf("<") == 0
        ? " " + this.book.volume
        : " - " + this.book.volume;
    },
    bookName() {
      return this.book.volume != "" &&
        (this.showBookVolumes ||
          this.typefree ||
          this.isFs ||
          this.showVolumes ||
          this.singleBook ||
          this.showVols ||
          this.closeVol === false)
        ? this.book.name + this.bookVolume
        : this.book.name + " " + this.volumePart;
    },
    author() {
      const authorsLen = this.book.authors_length;
      let mainAuth = "";
      return this.book.mainAuthorName;
      for (let i = 0; i < authorsLen; i++) {
        if (this.book[`authors_${i}_authorTypeId`] == 1) {
          mainAuth = this.book[`authors_${i}_name`];
        }
      }
      return mainAuth;
    },
    pubData() {
      return this.isSidraPart &&
        (this.showVolumes || this.showVols) &&
        this.realVolPart == "" &&
        (this.book.places || this.book.toyear)
        ? this.book.places + (this.book.places ? " " : "") + this.book.toyear
        : "";
    },
    showVolumePart() {
      return (
        this.book.volume != "" &&
        (this.showBookVolumes ||
          this.typefree ||
          this.isFs ||
          this.showVolumes ||
          this.singleBook ||
          this.showVols ||
          this.closeVol === false)
      );
    },
    getVolumes() {
      try {
        let mainVol = this.book.mainVolume;
        const vol_len = this.book.volumes_length;
        // let listIds = this.book.volumes;
        let list = [];
        for (let i = 0; i < vol_len; i++) {
          const bid = this.book[`volumes_${i}_id`];
          if (bid != mainVol) list.push(bid);
        }
        // listIds = listIds.filter((x) => x.id != mainVol).map((y) => y.id);
        return list;
      } catch (ex) {
        return [];
      }
    },
    listVol() {
      let list = [];

      this.getVolumes.forEach((e) => {
        list.push(this.getBookbyId(e, false));
      });

      return list;
    },

    bookYears() {
      let yearFrom = this.book?.fromyear;
      let yearTo = this.book?.toyear;
      return yearFrom == yearTo ? yearTo : yearFrom + " - " + yearTo;
    },
  },
  components: {
    nameBook,
    nameAuthor,
    itemBookVol,
    gzir,
    editPdfWindow,
    publishInfo,
  },
  methods: {
    ...mapActions("tabsManager", ["setBook", "toggleSplitter"]),
    ...mapActions("booklistComp", ["addListBooks"]),
    ...mapActions("freeSearchBooklistComp", ["addListBooksFree"]),
    ...mapActions({ bookCheck: "bookList/checkBook" }),
    ...mapActions("userFavoriteBooks", [
      "addFavoriteBook",
      "removeFavoriteBook",
    ]),
    ...mapActions("popupOnceComp", [
      "toggleVisible",
      "setSlotShow",
      "setBookId",
      "setInvisible",
    ]),
    /* openBook() {
      if (this.mefo) {
        debugger;
        let width = this.userSettings.settings.widthBook;
        if (width) width -= 12;
        else width = document.body.clientWidth * 0.75;

        const height = document.body.clientHeight * 0.85;
        this.openBookInNewWindow(null, false, "win_mefo_result", width, height);
        this.$store.state.tabsManager.openMefResultsBook++;
        //search for sections
        this.$emit("scrolltosec", this.book.id);
        this.$store.state.currentActiveListIndex = this.listIndex.toString();
        return;
      }
    }, */
    setDontScroll(payload) {
      if (this.freeSearchBookListStore)
        this.freeSearchBookListStore.dontScroll = payload;
    },
    checkAllBooks(payload) {
      if (this.freeSearchBookListStore)
        this.freeSearchBookListStore.checkAllBooks(payload);
    },
    setGzirimData(payload) {
      if (this.freeSearchBookListStore) {
        this.freeSearchBookListStore.setGzirimData(payload);
        if (!payload) this.freeSearchBookListStore.doBooksIdsRefresh();
      }
    },
    toggleGzirim(payload) {
      if (this.freeSearchBookListStore)
        this.freeSearchBookListStore.toggleGzirim(payload);
    },
    addHistory() {
      if (this.getNameListBook != "") {
        let payload = {
          type: "SEARCH",
          content: "",
        };
        this.$store.dispatch("bookList/addUserActionToHistory", payload);
      }
    },
    openResultInBook(page) {
      let tab = this.tabIdForOpenBook();
      this.$store.state.tabsManager.scrollToFsResult = true;
      open(this.book.id, page, tab, this.book.fs);
    },
    openBookInRealNewWindow() {
      const bookId = this.book.id;
      const results = this.book.fs == undefined ? 1 : -1;
      const fs = this.book?.fs;
      const fsName = fs ? fs.fs : 0;
      const end = fs ? fs.end : 0;
      const start = fs ? fs.start : 0;
      const tabId = Math.floor(Math.random() * 1000000);

      let sizeSetting = this.userSettings.settings["windowSize"];
      let size = sizeSetting
        ? JSON.parse(sizeSetting)
        : { width: screen.width, height: screen.height };
      const params = ["height=" + size.height, "width=" + size.width].join(",");

      window.open(
        (globalThis.APP_URL || "") +
          `#/book/${bookId}/p/-1/t/${tabId}/fs/${fsName}/start/${start}/end/${end}/c`,
        "_blank" + tabId,
        params
      );
      // openWin(
      //   `#/book/${bookId}/p/-1/t/${tabId}/fs/${fsName}/start/${start}/end/${end}/c`,
      //   "_blank" + tabId,
      //   params
      // );
    },
    openBookInNewWindow(
      e,
      delTabBook = false,
      tabId = null,
      width = null,
      height = null
    ) {
      //clearTimeout(this.clickTimer);
      bookwin.createWinBook(
        this.book.id,
        -1,
        width,
        height,
        tabId,
        null,
        this.book.fs,
        {},
        delTabBook
      );
    },
    openCusBookForEdit(bookId) {
      this.$store.dispatch("createBook/seBookForOpen", bookId);
      this.$store.dispatch("createBook/showCreate", true);
    },
    doToggleGzirim() {
      this.setDontScroll(true);
      this.toggleGzirim(this.book.index);
      this.getGzirimData();
      this.$emit("gzir", this.index);
    },
    getImage(page) {
      if (this.imgs[page]) return this.imgs[page];
      return "";
    },
    click() {
      return;
    },
    manageItemClicks(e, newTab, window = false) {
      // one day we will fix it
      /* if (e.detail == 1)
        this.clickTimer = setTimeout(() => {
          this.clickBook(e, newTab, window);
        }, 300);
      else {
        e.preventDefault();
        e.stopPropagation();
        return;
      } */
      this.clickBook(e, newTab, window);
    },
    async clickBook(e, newTab, window = false) {
      //set last active list
      this.$store.state.homePage = false;
      this.$store.state.currentActiveListIndex = this.listIndex.toString();
      this.$store.state.lastActiveList = this.searchMode ? 2 : 1;

      // update last book clicked in history
      this.$emit("updateActive", this.listIndex);

      /**@type {MouseEvent} */
      const trust = e ? e.isTrusted : false;
      if (trust && this.$_mobile) {
        this.$store.dispatch("mobile/setTab", "BOOK");
        this.$nextTick(() => {
          this.toggleSplitter();
        });
      }
      // this.$emit("active", this.book);
      let bookId = this.book.id;
      let page = -1;

      if (this.book.page) page = this.book.page;
      if (this.page) page = "P" + this.page;
      let extraData = {};
      if (this.searchMode && this.result === "" && this.book.fs != undefined)
        extraData.fs = this.book.fs;
      this.addHistory();
      //third param is if book should open in new tab. depends on user settings
      let tab;

      if (newTab) tab = new Date().getTime();
      else tab = this.tabIdForOpenBook();

      if (window) tab = "win_" + tab;
      this.$emit("open", { bookId, inx: this.inx });

      if (this.searchId && this.searchId !== "main") {
        let width = this.userSettings.settings.widthBook;
        if (width) width -= 12;
        else width = document.body.clientWidth * 0.75;

        const height = document.body.clientHeight * 0.85;
        this.openBookInNewWindow(null, false, "win_mefo_result", width, height);
        this.$store.state.tabsManager.openMefResultsBook++;
        //search for sections
        this.$emit("scrolltosec", this.book.id);
        this.$store.state.currentActiveListIndex = this.listIndex.toString();
        return;
      }

      open(bookId, page, tab, extraData.fs, window);
    },
    tabIdForOpenBook() {
      let tab = null;
      if (
        (this.userSettings.settings.newTabMode &&
          this.userSettings.settings.newTabMode == "1") ||
        this.isCurrentTabPinned
      ) {
        tab = new Date().getTime();
      }
      return tab;
    },
    toggleFavorites() {
      let books = this.booksChecked;
      this.getFavoriteCheckBooksCount == 1
        ? this.removeFavoriteBook({ books })
        : this.addFavoriteBook({ books });
    },
    toggleFavoritesItem() {
      let id = this.book.id;

      let books = [id];
      if (!this.showVolumes && this.hasVolumes && this.isVolumesHeader)
        books = books.concat(this.getVolumes);
      if (this.book.favorite)
        this.$store.dispatch("userFavoriteBooks/removeFavoriteBook", {
          books,
        });
      else this.$store.dispatch("userFavoriteBooks/addFavoriteBook", { books });
    },
    toggleBookDetailsVisible(id) {
      this.$store.dispatch("bookPopups/showBookDetailsVisible", id);
    },
    openListBooksAuthor(id, author, book) {
      this.addHistory();
      let payload = {
        id: id,
        type: "AUTHOR_LIST",
        content: author,
        data: book.mainAuthorId,
      };
      this.$store.dispatch("bookList/addUserActionToHistory", payload);
    },
    addQuickBtn() {
      this.$store.dispatch("popupOnceComp/setSlotShow", "add-quick-books");
      this.$store.dispatch("popupOnceComp/toggleVisible");
    },
    check($event, id, index) {
      let books = [id];
      if (!this.showVolumes && this.hasVolumes && this.isVolumesHeader)
        books = books.concat(this.getVolumes);

      //manage shift press
      if ($event.target.checked) {
        if (this.$store.state.shiftPress) {
          this.$emit("shiftCheck", index);
        } else this.$emit("lastCheck", index);
      }

      books.forEach((book) => {
        if (this.type == "book")
          this.bookCheck({ book, check: $event.target.checked });
        else
          this.freeSearchBookListStore.checkBook({
            book,
            check: $event.target.checked,
          });
      });
    },
    async openContexMenu() {
      this.$store.state.lastActiveList = this.searchMode ? 2 : 1;

      if (this.booksChecked.length > 0) {
        let hasCheck = this.booksChecked.filter((id) => id == this.book.id);
        if (hasCheck.length == 0) {
          if (this.type == "book") {
            await this.$store.dispatch("bookList/checkAllBooks", {
              check: false,
              search: "",
            });
          } else {
            await this.checkAllBooks({
              check: false,
              search: "",
            });
          }
        }
      }
      let books = [this.book.id];
      // if (!this.showVolumes && this.hasVolumes && this.isVolumesHeader)
      //   books = books.concat(this.getVolumes);

      books.forEach((book) => {
        if (this.type == "book") this.bookCheck({ book, check: true });
        else this.freeSearchBookListStore.checkBook({ book, check: true });
      });
      this.contextSelected = this.book;
    },
    closeContexMenu() {
      // this.select = false;
      // this.$store.dispatch("bookList/resetSelectedContex");
    },
    // נראה שלא בשימוש
    funcIconVol(str, id) {
      if (str == "author") this.openListBooksAuthor(id);
      else if (str == "details") {
        this.toggleBookDetailsVisible(id);
      } else if (str == "favorites") this.toggleFavorites(id);
    },
    toggleVol() {
      this.$emit("toggle-volumes", this.book.id, this.book.volumes_length - 1);

      if (this.userSettings.settings.sdarot_mode == "book") this.clickBook();
    },

    setVol(value) {
      this.$emit(
        "set-volumes",
        this.book.mainVolume,
        value,
        this.volumesCount - 1
      );
    },
    getGzirimData() {
      if (this.gzirim.show && this.gzirim.results == undefined) {
        let isList = this.freeSearchBookListStore.isSavedList;
        this.setGzirimData({ index: this.book.index, isList });
      }
    },
    openItem(e, newTab = false) {
      this.clickBook(null, newTab);
    },
    openItemInWindow(e) {
      this.clickBook(null, true, true);
    },
    saveInList() {
      // this.$store.dispatch("bookList/setSelectedContex", this.book.id);
      this.$store.dispatch("folders/setOpenTypePopup", "export").then(() => {
        this.$store
          .dispatch("folders/setListType", this.searchMode ? "free" : "book")
          .then(() => {
            this.$store.dispatch("folders/togglePopupFolder", true);
          });
      });
    },
    async removeFromList() {
      let payload = {
        title: this.$t("selectBook.deleteBookInList"),
        content: this.$t("selectBook.removeBookQ"),
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act == this.$t("general.no") || act == "") return;

      let folders = {
        id: this.getDataOfCurrentList.data.id,
        books: [this.book.id],
      };
      this.$store.dispatch("folders/userFolderListDeleteBooks", folders);
      const notification = {
        type: "success",
        message: this.$t("selectBook.removeSelectBook"),
        timeout: 2000,
        setting: {
          grid: "progress",
          nameIcon: "icon-garbage-color",
          position: "center",
        },
      };
      this.$notify(notification);
    },
    async addToHiddenBooks() {
      let books = this.booksChecked;
      let msg;
      msg =
        books.length == 1
          ? this.$t("hideBookQuestionSingle")
          : this.$t("hideBookQuestion");
      let payload = {
        title: this.$t("general.remove2"),
        content: msg,
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act != this.$t("general.yes")) {
        return;
      }

      let alreadyHidden = this.userSettings.settings.hiddenBooks
        ? this.userSettings.settings.hiddenBooks
        : [];
      if (typeof alreadyHidden == "string")
        alreadyHidden = JSON.parse(alreadyHidden);
      //remove dups
      let hiddenBooks = new Set([...books, ...alreadyHidden]);
      hiddenBooks = Array.from(hiddenBooks);
      try {
        await this.userSettings.setSettings(
          "hiddenBooks",
          JSON.stringify(hiddenBooks)
        );

        this.$store.dispatch("books/setHiddenBooks", hiddenBooks);

        msg =
          books.length == 1
            ? this.$t("hideBookSuccessSingle")
            : this.$t("hideBookSuccess");
        const notification = {
          type: "success",
          message: msg,
          timeout: 2000,
        };
        this.$notify(notification);
      } catch {
        const notification = {
          type: "error",
          message: "error occured",
          timeout: 2000,
        };
        this.$notify(notification);
      }
    },
    async removeHiddenBooks() {
      let books = this.booksChecked;
      let msg;
      msg =
        books.length == 1
          ? this.$t("hiddenbooks.sureCancelHiddenBooks")
          : this.$t("hiddenbooks.sureCancelHiddenBook");
      let payload = {
        title: this.$t("general.remove2"),
        content: msg,
        btns: [this.$t("general.yes"), this.$t("general.no")],
      };
      let act = await this.$msg(payload);
      if (act != this.$t("general.yes")) {
        return;
      }

      let alreadyHidden = this.userSettings.settings.hiddenBooks
        ? this.userSettings.settings.hiddenBooks
        : [];
      if (typeof alreadyHidden == "string")
        alreadyHidden = JSON.parse(alreadyHidden);
      //remove selected books
      let hiddenBooks = alreadyHidden.filter((b) => !books.includes(b));
      try {
        await this.userSettings.setSettings(
          "hiddenBooks",
          JSON.stringify(hiddenBooks)
        );

        this.$store.dispatch("books/unsetHiddenBooks", books);

        msg =
          books.length == 1
            ? this.$t("hiddenbooks.succeedCancel")
            : this.$t("hiddenbooks.succeedCancel");
        const notification = {
          type: "success",
          message: msg,
          timeout: 2000,
        };
        this.$notify(notification);
      } catch {
        const notification = {
          type: "error",
          message: "error occured",
          timeout: 2000,
        };
        this.$notify(notification);
      }
    },
    openEditPdfBook() {
      this.showEditPdf = true;
    },
    createShortcutForThisBook() {
      this.setInvisible();
      this.setBookId(this.book.id);
      this.setSlotShow("add-shortcut");
      this.toggleVisible();
    },
  },
  mounted() {
    this.getGzirimData();
  },
  created() {
    this.showVol = this.showVolumes;
  },
};
</script>

<style lang="scss">
$bg-hover1: #00000014;
body {
  direction: rtl;
  text-align: right;
}
// .red {
//   // background-color: red;
// }

.item-book {
  display: flex;
  position: relative;
  width: 100%;
  height: 37px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 3px;
  line-height: 37px;
  color: #000;
  font-size: 13px;
  cursor: pointer;
  direction: rtl;
  max-width: 100%;
  align-items: center;
  padding-left: 10px;
  &.item-vol {
    // padding-right: 32px;
    .container-text-item {
      padding-right: 20px;
    }
  }
  label {
    padding: 8px;
  }
  &.favorite.vol {
    .icons {
      // width: 55px;
    }
  }
  .container-text-item {
    position: relative;
    overflow: hidden;

    display: flex;
    /* white-space: nowrap; */
    /* text-overflow: ellipsis; */
    max-width: 100%;
    width: calc(100% - 10px);
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    .inner-text-item {
      width: auto;
      max-width: 100%;

      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &.machonim {
        max-width: calc(100% - 80px);
      }
      &.fs {
        max-width: calc(100% - 30px);
      }
    }
  }
  .check-item {
    opacity: 0;
    // transition: 0.3s;
    &.show-mobile {
      opacity: 1;
    }
  }
  &.check {
    .check-item {
      opacity: 1;
      // transition: 0.3s;
    }
  }
  .icons {
    // position: absolute;
    display: flex;
    // display: none;
    // width: 25px;
    left: 0;
    top: 0;
    height: 100%;
    padding: 6px 0;
    align-items: center;
    .delete,
    .edit {
      color: #626262;
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      // opacity: 0.6;
    }
    .edit {
      font-size: 29px;
    }
    &.icons-mobile {
      .icon-outer {
        display: block;
      }
    }
    .icon-outer {
      width: 24px;
      height: 24px;
      display: none;
      position: relative;
      border-radius: 50%;
      transition: 0.3s;
      color: #626262;

      &.icons-mobile {
        display: block;
      }
      &.books-author {
        stroke: var(--text-color2);
        fill: none;
      }
      .favorites-icon svg {
        stroke: #7b7b7b;

        // fill: #7B7B7B;
      }
      &.favorite {
        display: block;
      }
      &:hover {
        background-color: $bg-hover1;
      }
      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        fill: #626262;
      }
      &.favorites-icon .icon {
        fill: none;

        stroke: #626262;
      }
      &.favorites-icon.favorite .icon {
        fill: #626262;
        stroke: none;
      }
    }
  }
  &:hover {
    .icon-gzir {
      // opacity: 0.6;
    }
  }
}
// .item-book:active {
//   top: 1px;
// }
.icon-outer.favorite {
  svg {
    //  stroke: var(--text-color1);
    // fill: var(--text-color1);
  }
}
.item-vol {
  // padding: 0 32px;
  background-color: rgba(0, 0, 0, 0.05);
  background-color: rgba(255, 255, 255, 0.45);
}
.show-sum-vol {
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: block;
  font-size: 12px;
  text-align: center;
  border: 1px solid var(--custom-color3);
  // margin-top: 8px;
  line-height: 23px;
  // opacity: 0.6;
  min-width: fit-content;
  color: var(--custom-color1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  span {
    height: 100%;
    line-height: 24px;
  }
  &.small {
    width: 19px;
    height: 19px;
  }
  &.open {
    font-size: 19px;
    .close {
      transform: rotate(45deg);
      transition: 0.3s;
    }
  }
  &:hover {
    background-color: var(--border-color5);
  }
  .font-icon {
    font-size: 7px;
  }
  &.open {
    .close {
      opacity: 1;
      transition: 0.3s;
      display: block;
      .icon-outer {
        display: block;
      }
    }
  }
  .close {
    opacity: 0;
    transition: 0.3s;
    display: none;
  }
  &:hover:not(.open) {
    .num {
      opacity: 0;
      display: none;
    }
    .close {
      display: block;
      opacity: 1;
      // transform: rotate(45deg);
      font-size: 19px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
    }
  }
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    margin-top: -1px;
    margin-left: 1px;
  }
}
.show-num-fs {
  cursor: default;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: block;
  font-size: 12px;
  text-align: center;
  // border: 1px solid rgba(0, 0, 0, 0.1);
  // margin-top: 8px;
  line-height: 23px;
  color: var(--text-color1);
  position: relative;
  .icon-gzir {
    // display: block;
    transition: 0.3s;
    position: absolute;
    left: 0;
    border-radius: 50%;
    line-height: 25px;
    height: 24px;
    width: 22px;
    text-align: center;
    background-color: transparent;
    font-size: 18px;
    &:hover {
      background-color: #00000014;
    }
  }
  .icon-fill-gzir {
    display: none;
  }
  // .hover-gzirim {
  //   opacity: 0;
  //   display: none;
  //   transition: 0.3s;
  //   // font-size: 10px;
  //   line-height: 23px;
  //   height: 100px;
  //   border-radius: 50%;
  //   width: 24px;
  //   background-color: #00000014;
  //   &:hover {
  //     transform: rotate(180deg);
  //   }
  // }
  &.open {
    .hover-gzirim {
      opacity: 1;
    }
    .icon-gzir-empty {
      display: none;
    }
    .icon-fill-gzir {
      display: block;
      background-color: #00000014;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
    .icon-gzir {
      // opacity: 0;
    }
  }
  .num {
    width: 100%;
    display: block;
    text-align: center;
  }
  &:hover:not(.open) {
    .num {
      display: none !important;
    }
    .icon-gzir {
      // opacity: 0.6;
    }
  }
  &.open {
    .close {
      opacity: 1;
      transition: 0.3s;
      display: block;
    }
  }
  .close {
    opacity: 0;
    transition: 0.3s;
    display: block;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
.item-book.active {
  // border: 1px solid #d4d4d4;
  background-color: var(--text-color8) !important;
  border-left: 0;
  border-right: 0;
  border-right: 3px solid var(--custom-color1);
  padding: 0;
  padding-left: 9px; // tmp fix
}
.item-book:hover,
.item-book.select {
  // background-color: red;
  box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  // border: 1px solid #d4d4d4;
  // background-color: var(--text-color7);
  border-left: 0;
  // border-right: 0;

  // transition: 0s;
  position: relative;
  z-index: 1;
  &.vol {
    .icons {
      // width: 91px;
    }
  }
  .icons {
    // width: 76px;
  }
  .check-item {
    opacity: 1;
  }
  .icon-outer {
    display: block;
  }
}

.item-book .name-author {
  // color: #000;
  font-size: 12px;
  padding-right: 7px;
}
.item-book .name-book {
  color: #000;
  font-size: 13px;
  font-weight: 600;
}
[book-item-size="compact"] {
  .item-book {
    height: 25px;
    line-height: 25px;
    .show-sum-vol {
      height: 20px;
      width: 20px;
      line-height: 20px;
      .num {
        line-height: 20px;
      }
    }
    .show-sum-vol span {
      line-height: 20px;
    }
  }
}
[text-size="large"] {
  .item-book .name-author {
    font-size: 14px;
  }
  .item-book .name-book {
    font-size: 15px;
  }
}
.show-machonim span {
  // border-radius: 50%;
  // height: 24px;
  // width: 24px;
  // display: block;
  // font-size: 12px;
  // text-align: center;
  // border: 1px solid var(--custom-color1);
  // color: var(--custom-color1);
  // line-height: 23px;
  // position: relative;
  // font-weight: 500;
}
.machon {
  height: 18px;
  color: var(--custom-color1);
  font-size: 10px;
  font-weight: 600;
  background-color: var(--bg-color10);
  border-radius: 9px;
  padding: 0 5px;
  white-space: nowrap;
  line-height: 18px;
}
.icon-minus {
  font-size: 22px !important;
  line-height: 22px !important;
  height: 24px !important;
}
.item-book:hover .icon-fill-gzir.icon-outer,
.item-book:hover .open .icon-gzir-empty.icon-outer {
  display: none;
}
.item-book:hover .open .icon-fill-gzir.icon-outer,
.item-book .icons .icon-outer.open {
  display: block;
}
.tziun-resulte {
  font-size: 25px;
  text-align: center;
  align-items: center;
  display: flex;
  line-height: 26px;
  display: block !important;
}
.key-resulte {
  color: #626262;
  transform: scale(0.9);
  .icon-outer {
    display: block !important;
  }
}
.edit-book {
  font-size: 39px;
}
</style>
